import Error404 from "../components/UI/Error404";

export default function Error404Page() {
  return <Error404 />;
}
